export default __webpack_public_path__ + "static/True-Vine-Media-44f541e5c9dda05cefadfa0ff98d6b4d.webp";